import React, { useState, useEffect, useRef } from 'react'; 
import { Link } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { usePopup } from './PopupContext';
import Ourcourses from './Ourcourses'

const Header = () => {
  const [isCoursesOpen, setIsCoursesOpen] = useState(false);
  const { setShowPopup } = usePopup();
  const coursesMenuRef = useRef(null);

  const toggleCoursesMenu = () => {
    setIsCoursesOpen(!isCoursesOpen);
  };

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  // Click outside to close mega menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (coursesMenuRef.current && !coursesMenuRef.current.contains(event.target)) {
        setIsCoursesOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const closeMenu = () => {
    setIsCoursesOpen(false);
  };

  return (
    <header className="headersection myfont1">
      <h1 className="visually-hidden">Fortune Cloud Technologies</h1>

      <nav className="navbar navbar-expand-lg" style={{ width: '100%',zIndex: 1040 }} role="navigation">
        <div className="container-fluid">
          <div className='d-none d-sm-block'>
            <Link className="navbar-brand text-center" to="/" title="Fortune Cloud Logo" aria-label="Fortune Cloud Logo">
              <img src="/assets/images/fctlogo.png" alt="Fortune Cloud Technologies Logo" width="140" className="img-fluid" loading="lazy"/>
            </Link>
          </div>
          <div className='d-block d-sm-none'>
            
            <div className="container">
              <div className="row align-items-center">
                {/* Logo - full width on small screens, auto on larger */}
                <div className="col-4 col-sm-auto text-center text-sm-start mb-2 mb-sm-0">
                  <Link className="navbar-brand" to="/" title="Fortune Cloud Logo" aria-label="Fortune Cloud Logo">
                    <img
                      src="/assets/images/fctlogo.png"
                      alt="Fortune Cloud Technologies Logo"
                      className="img-fluid"
                      loading="lazy"
                    />
                  </Link>
                </div>

                {/* Button - full width on small, auto on larger */}
                <div className="col-6 col-sm-auto text-center text-sm-start">
                  <Link to='/courses' className="btn bgcolor1 btn-sm position-relative text-white fw-bold" title="Explore Our Courses" aria-label="Explore Our Courses">
                    Explore Our Courses
                  </Link>
                </div>
                <div className="col-1 col-sm-auto text-center text-sm-start">
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                </div>
              </div>
            </div>

          </div>
          

          

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              {/* Our Courses Mega Menu */}
              <li className="nav-item position-relative" ref={coursesMenuRef}>
                <span
                  className="btn me-md-2 text-white bgcolor1 btn-outline-primary fw-semibold d-none d-sm-block"
                  style={{ cursor: 'pointer' }}
                  onClick={toggleCoursesMenu}
                >
                  Explore Our Courses
                </span>

                {isCoursesOpen && (
                  <div
                    className="bg-white border-top shadow isCoursesOpen">
                    <button
                      className="btn-close btn-close-dark closebtn1"
                      aria-label="Close"
                      onClick={closeMenu}
                    ></button>

                    <div className="container-fluid px-3">
                      <Ourcourses/>
                    </div>
                  </div>
                )}
              </li>

              {/* Other Nav Items */}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle textcolor2 fontsize1"
                  href="/#"
                  id="navbarDropdown2"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  title="Explore More"
                  aria-label="Explore More"
                >
                  <strong>Explore More</strong>
                </a>
                <ul className="dropdown-menu megamenu" aria-labelledby="navbarDropdown2">
                  <li><Link className="dropdown-item" to="/About-Us" title="Fortune Cloud About Us" aria-label="Fortune Cloud About Us">About Us</Link></li>
                  <li><Link className="dropdown-item" to="/Contact" title="Fortune Cloud Contact Us" aria-label="Fortune Cloud Contact Us">Contact</Link></li>
                  <li><Link className="dropdown-item" to="/Blog" title="Fortune Cloud Blogs" aria-label="Fortune Cloud Blogs">Blog</Link></li>
                </ul>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/Success-Stories" title="Fortune Cloud Success Stories" aria-label="Fortune Cloud Success Stories"><b>Success Stories</b></Link>
              </li>
              <li className="nav-item d-block d-sm-none">
                <Link className="nav-link" to="/batchschedule" title="Fortune Cloud Batch Schedule" aria-label="Fortune Cloud Batch Schedule"><b>Batch Schedule</b></Link>
              </li>
              <li className="nav-item d-block d-sm-none">
                <Link className="nav-link" onClick={handleEnquiryClick} title="Fortune Cloud Enquiry Form" aria-label="Enquiry Form"><b>Enquiry Form</b></Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/recruiters" title="Fortune Cloud Recruiters" aria-label="Recruiters"><b>For Recruiters</b></Link>
              </li>
            </ul>

            <div className="d-grid gap-2 d-md-flex justify-content-md-end">
              <a className="btn me-md-2 brcolor_and_txcolor fw-semibold" href="/Free-Placement-Calls" target="_blank" title="Free Placement Support from Fortune Cloud" aria-label="Free Placement Calls">Free Placement Calls</a>
              <a
                className="btn brcolor_and_txcolor fw-semibold"
                href="https://lms.fortunecloudindia.com/"
                target="_blank"
                rel="noreferrer"
                title="Fortune Cloud Student Login" aria-label="Student Login"
              >
                <i className="bi bi-person-circle"></i> Student Login
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
